import API, { graphqlOperation } from "@aws-amplify/api";
import { USER_ROLES } from "../Constants";

const GET_UR_ENTITIES_QUERY = /* GraphQL */ `
    query GetUREntitiesForPartitions {
        general {
            getUREntities {
                id
                name
            }
        }
    }
`;

export const mapEntityUsersToPartitionItems = (entityUsers = []) =>
    entityUsers.map((e) => ({
        id: String(e.id),
        name: e.name,
        clientID: e.id,
        groupName: `Entity-${e.name}`,
        logoUrl: null,
    }));

export const mapUrEntitiesToPartitionItems = (urEntities = []) =>
    urEntities.map((e) => ({
        id: String(e.id),
        name: e.name,
        clientID: e.id,
        groupName: `Entity-${e.name}`,
        logoUrl: null,
    }));

const userHasVendexSuperUser = (user) => {
    const roles = user?.userRegistryData?.userRoles || [];
    return roles.some((r) => r.name === USER_ROLES.VENDEX_SUPER_USER);
};

export const fetchPartitionEntities = async (user) => {
    const entityUsersFallback = mapEntityUsersToPartitionItems(user?.userRegistryData?.entityUsers || []);

    if (userHasVendexSuperUser(user)) {
        try {
            const { data } = await API.graphql(graphqlOperation(GET_UR_ENTITIES_QUERY));
            const urEntities = data?.general?.getUREntities;
            if (urEntities && urEntities.length > 0) {
                return mapUrEntitiesToPartitionItems(urEntities);
            }
        } catch (e) {
            console.log("getUREntities fetch error:", e);
        }
    }

    return entityUsersFallback;
};